require("./admin/js/bootstrap-formhelpers/selectbox.js");

require("./admin/js/jquery.select-chain.js");
require("./admin/js/jquery.imgareaselect/scripts/jquery.imgareaselect.js");
require("./admin/js/jquery.imgareaselect/css/imgareaselect-default.css");

require("./_common/js/gmap/index.js");
require("./_common/js/hapi-lazy.js");
require("./_common/js/hapi-background-slides.js");
require("./_common/js/hapi-background-video.js");
require("./_common/js/hapi-page-extra.js");

require("./_common/js/input-type-number.js");
require("./_common/js/input-type-number.scss");

require("./_common/js/hapi-gridcell-popmenu.js");
require("./_common/js/hapi-gridcell-popmenu.scss");

require("./admin/js/admin_custom.js");

require('./_common/css/grille_rwd.scss');
require('./_common/css/table_rwd.scss');
require("./admin/css/admin_custom.scss");

require("./admin/colorpicker/index.js");
require("./admin/js/input-slider.js");